import { render, staticRenderFns } from "./FormProcessDesign.vue?vue&type=template&id=2ab9778a&scoped=true"
import script from "./FormProcessDesign.vue?vue&type=script&lang=js"
export * from "./FormProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./FormProcessDesign.vue?vue&type=style&index=0&id=2ab9778a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9778a",
  null
  
)

export default component.exports